export default __webpack_public_path__ + "3cb10102aac8e5ab5e3a94c6e6155dc9.png";